var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { EInvoiceStatusFilter, } from "@/api/partners/partners.types";
import { createContext } from "react";
export var initialState = {
    invoices: [],
    filteredInvoices: [],
};
export var InvoiceContext = createContext(initialState);
export var InvoiceDispatchContext = createContext({});
export function billingOptionsReducer(state, action) {
    switch (action.type) {
        case "setInvoices":
            return __assign(__assign({}, state), { invoices: action.payload, filteredInvoices: action.payload });
        case "addMoreInvoices":
            return __assign(__assign({}, state), { invoices: __spreadArray(__spreadArray([], __read(state.invoices), false), __read(action.payload), false) });
        case "filterInvoices":
            return __assign(__assign({}, state), { filteredInvoices: state.invoices.filter(function (invoice) {
                    var _a, _b;
                    return ((_b = (_a = action.payload.status) === null || _a === void 0 ? void 0 : _a.split(",")) === null || _b === void 0 ? void 0 : _b.includes(invoice.paymentStatus)) ||
                        action.payload.status === EInvoiceStatusFilter.ANY;
                }) });
        default:
            return state;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmlsbGluZ0NvbnRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJiaWxsaW5nQ29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEVBQ0wsb0JBQW9CLEdBRXJCLE1BQU0sK0JBQStCLENBQUM7QUFDdkMsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQU90QyxNQUFNLENBQUMsSUFBTSxZQUFZLEdBQW9CO0lBQzNDLFFBQVEsRUFBRSxFQUFFO0lBQ1osZ0JBQWdCLEVBQUUsRUFBRTtDQUNyQixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sY0FBYyxHQUFHLGFBQWEsQ0FBQyxZQUFZLENBQUMsQ0FBQztBQUMxRCxNQUFNLENBQUMsSUFBTSxzQkFBc0IsR0FBRyxhQUFhLENBQ2pELEVBQWlELENBQ2xELENBQUM7QUFFRixNQUFNLFVBQVUscUJBQXFCLENBQ25DLEtBQXNCLEVBQ3RCLE1BQW1DO0lBRW5DLFFBQVEsTUFBTSxDQUFDLElBQUksRUFBRTtRQUNuQixLQUFLLGFBQWE7WUFDaEIsNkJBQ0ssS0FBSyxLQUNSLFFBQVEsRUFBRSxNQUFNLENBQUMsT0FBTyxFQUN4QixnQkFBZ0IsRUFBRSxNQUFNLENBQUMsT0FBTyxJQUNoQztRQUVKLEtBQUssaUJBQWlCO1lBQ3BCLDZCQUNLLEtBQUssS0FDUixRQUFRLHlDQUFNLEtBQUssQ0FBQyxRQUFRLGtCQUFLLE1BQU0sQ0FBQyxPQUFPLGFBQy9DO1FBRUosS0FBSyxnQkFBZ0I7WUFDbkIsNkJBQ0ssS0FBSyxLQUNSLGdCQUFnQixFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUNyQyxVQUFDLE9BQU87O29CQUNOLE9BQUEsQ0FBQSxNQUFBLE1BQUEsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLDBDQUNqQixLQUFLLENBQUMsR0FBRyxDQUFDLDBDQUNWLFFBQVEsQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDO3dCQUNuQyxNQUFNLENBQUMsT0FBTyxDQUFDLE1BQU0sS0FBSyxvQkFBb0IsQ0FBQyxHQUFHLENBQUE7aUJBQUEsQ0FDckQsSUFDRDtRQUNKO1lBQ0UsT0FBTyxLQUFLLENBQUM7S0FDaEI7QUFDSCxDQUFDIn0=